import { projectStore } from "@droid/project-v2-interface"
import { ProjectContext } from "../../contexts"
import { ButtonConfirm } from "@fanfanlo"
import { Box, Button } from "@mui/material"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
export function DeleteProjectButton() {
    const { t } = useTranslation("droid-project-v2-ui/ui/components/content")
    const project = useContext(ProjectContext)
    const projectUlid = project.ulid
    const handleDelete = () => {
        projectStore.removeProject(projectUlid)
    }
    const content = <Box style={{textAlign: 'center'}}>
        <span style={{color:"#FF0000"}}>{project.name}</span>
        <br/>
        <span>{t('content.confirmDelete')}</span>
    </Box>
    return (
        <>
            <ButtonConfirm
            title={t('content.title')}
            content={content}
            onConfirm={handleDelete}>
                <Button
                data-testid="DeleteProjectButton__deleteButton__01JFXYZU1J5K6L7M8N9O0P1Q2"
                data-test-comment="删除项目按钮，点击后弹出确认对话框，确认后删除项目"
                id="project-simple-title-list-del-btn"
                data-id="project-simple-title-list-del-btn"
                >
                    {t('content.delete')}
                </Button>
            </ButtonConfirm>
        </>
    )
}
